import * as React from 'react';
import { Dropdown, Image, Responsive } from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
// import { hasPermissionToAccessPage } from 'helpers/permission-helper';
import { LanguageCode } from 'types/tenants/language-code';
// import { Link } from 'react-router-dom';
// import { Permission } from 'types/permission';
import { translations } from 'types/translations';
import './styles.css';

export interface ConnectedProps {
  language: LanguageCode;
  username: string;
  permissions: string;
  hasEnterpriseLogin: boolean;
  isOnline?: boolean;
}

export interface ActionProps {
  logout: () => void;
}

export type Props = ConnectedProps & ActionProps;

export const ProfileMenu: React.StatelessComponent<Props> = (props) => {
  const i18n = getI18n();

  // const isAllowedUsers: boolean = hasPermissionToAccessPage(Permission.Users, props.permissions);
  // const isAllowedDocumentation: boolean = hasPermissionToAccessPage(Permission.Documentation, props.permissions);

  // const isAllowedSettings: boolean =
  //   hasPermissionToAccessPage(Permission.TenantProviderCredentials, props.permissions) ||
  //   hasPermissionToAccessPage(Permission.TenantCustomSettings, props.permissions) ||
  //   hasPermissionToAccessPage(Permission.TenantPreferences, props.permissions);

  const trigger = (
    <span>
      <Responsive minWidth={Responsive.onlyComputer.minWidth} as="span" >
        {props.username}
      </Responsive>
      <Image avatar={true} src="./icons/profile.svg" className="user-image" />
    </span>
  );

  return (
    <div className="user-profile">
      <Dropdown
        trigger={trigger}
        className="user-profile-dropdown"
        direction="left"
        icon={null}
      >
        <Dropdown.Menu>

          {/*!props.hasEnterpriseLogin &&
            <Dropdown.Item className="user-profile-link" as={Link} exact="true" to={`${process.env.PUBLIC_URL}/user/profile`}>
              <Image src="./icons/user.svg" /> <span className="link-text">{i18n.t(translations.UserProfile)}</span>
            </Dropdown.Item>
          */}

          {/*<Dropdown.Item className="device-info-link" as={Link} exact="true" to={`${process.env.PUBLIC_URL}/deviceInfo`}>
            <Image className="device-info-icon" src="./icons/device.svg" /> 
            <span className="link-text">{i18n.t(translations.DeviceInfo)}</span>
          </Dropdown.Item>
          */}
          {/*!props.hasEnterpriseLogin && isAllowedUsers &&
            <Dropdown.Item className="users-link" as={Link} exact="true" to={`${process.env.PUBLIC_URL}/users`} disabled={!props.isOnline}>
              <Image src="./icons/users.svg" /> <span className="link-text">{i18n.t(translations.Users)}</span>
            </Dropdown.Item>
          */}

          {/*isAllowedSettings &&
            <Dropdown.Item className="settings-link" as={Link} exact="true" to={`${process.env.PUBLIC_URL}/settings`} disabled={!props.isOnline}>
              <Image src="/icons/settings.svg" /> <span className="link-text">{i18n.t(translations.Settings)}</span>
            </Dropdown.Item>
          */}

          {/*isAllowedDocumentation &&
            <a href="https://drive.google.com/drive/folders/1wytr_tnzZ6jnZbh8RWVL0u_cuCAplLsT" role="option"
             className="item documentation-link" target="_blank">
              <Image src="./icons/docs.svg" /> <span className="link-text">{i18n.t(translations.Documentation)}</span>
            </a>
          */}

          <Dropdown.Item className="logout-link" onClick={props.logout}>
            <Image src="./icons/logout.svg" /> <span className="link-text">{i18n.t(translations.Logout)}</span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/profile-menu/component.tsx